import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'samples-buy_from_samples_carousel-click';

/**
 * When retailer adds a product to cart from "Buy from Samples" carousel, this gets triggered
 */
export function trackSamplesBuyFromSamplesCarouselClick(
  Surface_string: string,
  Product_p_2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Surface_string, Product_p_2 },
  });
}
